import React from "react";
import { Layers } from "lucide-react";
import { STEPS, CATEGORIES, BENEFITS, slugify } from "./constants";

export function LandingHowItWorks() {
  return (
    <section id="how" className="py-20 border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">How it works</div>
          <h2 className="font-display font-black tracking-tight text-4xl lg:text-5xl mt-3">A four-step intelligence loop</h2>
        </div>
        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {STEPS.map((s, i) => {
            const I = s.icon;
            return (
              <li key={s.n} className="relative border border-zinc-200 rounded-md p-6 bg-white" data-testid={`how-step-${i + 1}`}>
                <div className="absolute top-4 right-4 text-zinc-300 font-display font-black text-3xl">{s.n}</div>
                <I className="w-6 h-6 text-teal mb-3" />
                <div className="font-display font-bold text-xl">{s.title}</div>
                <p className="mt-2 text-sm text-zinc-700 leading-relaxed">{s.body}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

export function LandingCategories() {
  return (
    <section id="categories" className="py-20 border-b border-zinc-200 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">What you can search</div>
          <h2 className="font-display font-black tracking-tight text-4xl lg:text-5xl mt-3">Intel Categories</h2>
          <p className="mt-4 text-zinc-700 max-w-2xl mx-auto">Every record is structured, evidence-based, and verifiable across four core domains.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {CATEGORIES.map((c) => (
            <div key={c.title} className="border border-zinc-200 rounded-md p-6 bg-white" data-testid={`category-${slugify(c.title)}`}>
              <div className="w-9 h-9 rounded-md mb-3 flex items-center justify-center" style={{ background: `${c.color}1a`, color: c.color }}>
                <Layers className="w-5 h-5" />
              </div>
              <div className="font-display font-bold text-lg">{c.title}</div>
              <ul className="mt-3 space-y-1 text-sm text-zinc-700">
                {c.items.map((it) => <li key={it} className="flex items-center gap-2"><span className="w-1 h-1 rounded-full bg-zinc-400" /> {it}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function LandingWhyHotels() {
  return (
    <section className="py-20 border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">Why join</div>
          <h2 className="font-display font-black tracking-tight text-4xl lg:text-5xl mt-3">Why Hotels Join</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {BENEFITS.map((b) => {
            const I = b.icon;
            return (
              <div key={b.title} className="border border-zinc-200 rounded-md p-6 bg-white" data-testid={`benefit-${slugify(b.title)}`}>
                <I className="w-6 h-6 text-teal mb-3" />
                <div className="font-display font-bold text-lg">{b.title}</div>
                <p className="mt-2 text-sm text-zinc-700 leading-relaxed">{b.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
